import { CatalogData } from "../../data/catalogData";
import { DeclarationData } from "../../data/declarationData";
import { OperationRequestData } from "../../data/operationRequestData";
import { clientTime } from "../../utilities/index";
import { Http } from "./http";
import { appConfig } from "fs-pb-vue2/config";

/**Запросы к методам провередния операций дбо*/
export class OperationsApi {
  /**
   * Выполнение запроса операции.
   * @param partURL Частичный URL, добавляется к базовому.
   * @param ord Данные операции.
   */
  static async operationSendAsync(
    partURL: string,
    ord: OperationRequestData
  ): Promise<any> {
    return await Http.post(partURL, ord);
  }

  /**
   * Выполнение обработки изменения реквизита.
   * @param ord Данные операции.
   * @returns Данные по операции после запроса assign
   */
  static async assignOperationSendAsync(
    ord: OperationRequestData
  ): Promise<OperationRequestData> {
    // Выполняем запрос.
    const respData = await OperationsApi.operationSendAsync(
      "WebClient/Assign",
      ord
    );

    return new OperationRequestData(respData.data);
  }

  /**
   * Выполнение проверки операции.
   * @param ord Данные операции.
   * @returns Данные по операции после запроса prepare
   */
  static async prepareOperationSendAsync(
    ord: OperationRequestData
  ): Promise<OperationRequestData> {
    // Выполняем запрос.
    const respData = await OperationsApi.operationSendAsync(
      "WebClient/Prepare",
      ord
    );
    return new OperationRequestData(respData.data);
  }

  static async getFileLink(file: any): Promise<any> {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("clientTime", clientTime());
    const res = await Http.post(`WebClient/SaveFile`, formData);

    return res.data || "";
  }  

  /**
   * Выполнение подтверждения операции.
   * @param ord Данные операции.
   * @returns Данные по операции после запроса execute
   */
  static async executeOperationSendAsync(
    ord: OperationRequestData
  ): Promise<OperationRequestData> {
    // Выполняем запрос.
    const respData = await OperationsApi.operationSendAsync(
      "WebClient/Execute",
      ord
    );
    return new OperationRequestData(respData.data);
  }

  static async getDocumentFileData(id: number, name: string): Promise<void> {
    await fetch(`${appConfig.apiUrl}WebClient/GetDocumentFileData?id=${id}&clientTime=${clientTime()}&typeSource=0`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/pdf'
      }
    }).then(res => res.blob()).then(data => {
      let url = URL.createObjectURL(data);

      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      a.click();
    });
  }

  /**
   * Выполнение проверки операции (неавторизованная операция).
   * @param ord Данные операции.
   * @returns Данные по операции после запроса prepare
   */
  static async prepareAnonymousOperationSendAsync(
    ord: OperationRequestData
  ): Promise<OperationRequestData> {
    // Выполняем запрос.
    const respData = await OperationsApi.operationSendAsync(
      "WebClient/PrepareAnonymous",
      ord
    );
    return new OperationRequestData(respData.data);
  }

  /**
   * Выполнение подтверждения операции (неавторизованная операция).
   * @param ord Данные операции.
   * @returns Данные по операции после запроса execute
   */
  static async executeAnonymousOperationSendAsync(
    ord: OperationRequestData
  ): Promise<OperationRequestData> {
    // Выполняем запрос.
    const respData = await OperationsApi.operationSendAsync(
      "WebClient/ExecuteAnonymous",
      ord
    );
    return new OperationRequestData(respData.data);
  }

  /**
   *  Получение данных операции.
   * @param id ИД операции в каталоге.
   * @returns Данные операции.
   */
  static async getRespondentAsync(id: number): Promise<CatalogData> {
    const respData = await Http.get(
      `WebClient/GetRespondent?operationId=${id}&clientTime=${clientTime()}&typeSource=0`
    );

    return new CatalogData(respData?.data);
  }

  /**
   * Получение декларации операции.
   * @param id ИД операции в каталоге.
   */
  static async getDeclarationAsync(id: number, codeOfByCard: string, codeOfToExt: string): Promise<DeclarationData> {
    const respData = await Http.get(
      `WebClient/GetDeclaration?respondentCode=${id}&clientTime=${clientTime()}&typeSource=0`
    );

    return new DeclarationData(id, respData?.data, codeOfByCard, codeOfToExt);
  }

  /**
   * Получение операции для повтора.
   * @param id ИД операции для повтора.
   * @returns>Данные операции.
   */
  public static async getRepeatOperationAsync(
    id: number
  ): Promise<OperationRequestData> {
    const respData = await Http.get(
      `WebClient/RepeatOperation?operationId=${id}&clientTime=${clientTime()}&typeSource=0`
    );
    // парсим данные
    return new OperationRequestData(respData?.data);
  }

  /**
   * Повтор отслылки кода подтверждения.
   * @param id ИД операции в каталоге.
   */
  static async reCreateVerificationCodeAsync(id: number): Promise<void> {
    await Http.get(
      `WebClient/ReCreateVerificationCode?operationId=${id}&clientTime=${clientTime()}&typeSource=0`
    );
  }
}
